<template>
	<b-card class="mb-3">
				
		<b-container fluid>
			<b-tabs content-class="mt-3"  class="bankSubtab">
			
			<b-tab title="Bank Details" active>
					<!-- ==================================================================================== -->
					
				<b-container fluid>
					<b-row class="mt-3 mb-2">
						
						<b-col class="text-right">
							<b-link v-if="noAddaccount==0" @click="noAddaccount=1" variant="dark" pill class="mr-2" ><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Bank Information</b-link>
							<!--<b-button variant="dark" pill  @click="downloadcsv()"><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Export</b-button>-->
						</b-col>
					</b-row>
				</b-container>
					<b-container fluid class="mb-5" v-if="noAddaccount==1">
						<form ref="form" @submit.stop.prevent="handleSubmitBank">	
						<b-row>
						<b-col class="bankAccountFotmLayout">
						 <!-- b-form-group label="Beneficiary Name">
							<b-form-input class="mb-0" v-model="profile.beneficiary" size="sm"></b-form-input>
						</b-form-group> -->
						
							<b-form-group label-for="beneficiary-input" label-size="sm" label-class="mb-2" class="mb-1" :state="profileState.beneficiary" invalid-feedback="Beneficiary name is required!" label-cols-sm="3" content-cols-sm label="*Beneficiary Name" >
							<b-form-input id="beneficiary-input" :state="profileState.beneficiary" v-model="profile.beneficiary" @focusin="profileState.beneficiary = null" size="sm"></b-form-input>
							</b-form-group>
						
							<b-form-group label-for="bank_name-input" label-size="sm" label-class="mb-2" class="mb-1" :state="profileState.bank_name" invalid-feedback="Bank name is required!" label-cols-sm="3" content-cols-sm label="*Bank Name">
							<b-form-input id="bank_name-input" :state="profileState.bank_name" v-model="profile.bank_name"  @focusin="profileState.bank_name = null" size="sm"></b-form-input>
							</b-form-group>
						
									
							<b-form-group label-for="account-input" label-size="sm" label-class="mb-2" class="mb-1" :state="profileState.account" :invalid-feedback="profileError.account" label-cols-sm="3" content-cols-sm label="*Account Number">
							<b-form-input :type="accountInput"  id="account-input" :state="profileState.account" v-model="profile.account"  @focusin="profileState.account = null" size="sm" @focus="accountInput ='text'" @blur="accountInput='password'" ></b-form-input>
							</b-form-group>
												
							 
									
							<b-form-group label-for="conf_account-input" label-size="sm" label-class="mb-2" class="mb-1" :state="profileState.conf_account" :invalid-feedback="profileError.conf_account" label-cols-sm="3" content-cols-sm label="*Confirm Account">
							<b-form-input id="conf_account-input" :state="profileState.conf_account" v-model="profile.conf_account"  @focusin="profileState.conf_account = null" size="sm" @paste.prevent ></b-form-input>
							</b-form-group>
												
							 
									
							
						
							
						
							<b-form-group label-for="ifsc-input" label-size="sm" label-class="mb-2" class="mb-1" :state="profileState.ifsc" invalid-feedback="Please specify a valid IFSC CODE!" label-cols-sm="3" content-cols-sm label="*IFSC Code" >
							<b-form-input id="ifsc-input" :state="profileState.ifsc" v-model="profile.ifsc"  @focusin="profileState.ifsc = null" size="sm" @keypress="spaceNotAllow" ></b-form-input>
							</b-form-group>  
							
							<b-form-group :state="profileState.account_type"  label-for="account_type-input" label-size="sm" label-class="mb-2" class="mb-1" invalid-feedback="Account type is required!" label-cols-sm="3" content-cols-sm label="*Account Type">
										<b-form-select v-model="profile.account_type" id="status-input" :state="profileState.account_type" v-on:change="profileState.account_type = null" size="sm">
										<b-form-select-option value="" hidden selected placeholder="Account Type">*Select Account Type</b-form-select-option>
										<b-form-select-option value="Savings">Savings</b-form-select-option>
										<b-form-select-option value="Current">Current</b-form-select-option>
										</b-form-select>
									</b-form-group>
							
						
							<b-form-group :state="profileState.status"  label-for="status-input" label-size="sm" label-class="mb-2" class="mb-1" invalid-feedback="status is required!" label-cols-sm="3" content-cols-sm label="*Select status">
										<b-form-select v-model="profile.status" id="status-input" :state="profileState.status" v-on:change="profileState.status = null" size="sm">
										<b-form-select-option value="" hidden selected placeholder="select status">*Select status</b-form-select-option>
										<b-form-select-option value="1">Active</b-form-select-option>
										<b-form-select-option value="0">In Active</b-form-select-option>
										</b-form-select>
									</b-form-group>
							
						</b-col>
						</b-row>
						
						<b-row class="mt-2">
							<b-col class="text-right bankAccountFotmbtnLayout ">
								 <!--<b-button variant="dark" pill  @click="saveProfile()"><b-icon class="mr-2" icon="upload" aria-hidden="true"></b-icon>Save Account</b-button> -->
								 <b-button type="reset" variant="light" @click="noAddaccount=0" class="btn-solid-cancel" pill>Cancel</b-button> <b-button pill type="submit" variant="dark" class="mr-2">Save Account</b-button>
								 
							</b-col>
						</b-row>
						</form>
					</b-container>
					<b-container fluid>
						<b-row>
							<b-col class="col-md-12 col-sm-12 col-xs-12">
								<div class="container-box">
									<b-row class="mt-4 px-3">
										<b-col lg="6" class="text-left">
											<span class="mr-2">Show</span>
											<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
											</b-form-select>
										
										</b-col>
										<b-col lg="4" offset-md="2">
											<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
												<b-input-group size="sm">
													<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
													</b-form-input>
													<b-input-group-append>
														<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
													</b-input-group-append>
												</b-input-group>
											</b-form-group>
										</b-col>
									</b-row>
									<b-row class="px-3 pt-3"> 
										<b-col lg="12">
											<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="recordsBank" :fields="fieldsbank" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
												<template v-slot:cell(status)="row">
													<b-badge pill variant="warning" v-if="row.value == 0">In Active</b-badge>
													<b-badge pill variant="success" v-else>Active</b-badge>
													
												</template>
												
												<template v-slot:cell(actions)="row">
													<!-- <b-button pill variant="outline-primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button>-->
													<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="showDeleteModal(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
												</template>
											</b-table>
										</b-col>
									</b-row>
									<b-row class="px-3">
										<b-col lg="6" class="text-left">
											<span class="mr-2">Showing {{currentPage}} to {{(perPage>recordsBank.length)?recordsBank.length:perPage}} of {{recordsBank.length}} entries</span>
										</b-col>
										<b-col lg="3" offset-md="3">
											<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
										</b-col>
									</b-row>
								</div>
							</b-col>
						</b-row>
					</b-container>

					<!-- ==================================================================================== -->
			</b-tab>
			<b-tab title="Wallet Details">
				<!-- ==================================================================================== -->
					
				<b-container fluid>
					<b-row class="mt-3 mb-2">
						
						<b-col class="text-right">
							<b-link v-if="noAddwallet==0" @click="noAddwallet=1" variant="dark" pill class="mr-2" ><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Wallet</b-link>
							<!--<b-button variant="dark" pill  @click="downloadcsv()"><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Export</b-button>-->
						</b-col>
					</b-row>
				</b-container>
					<b-container fluid class="mb-5" v-if="noAddwallet==1">
						<form ref="form" @submit.stop.prevent="handleSubmitWallet">	
						<b-row>
						<b-col class="bankAccountFotmLayout">
							<b-form-group label-for="beneficiary-input" label-size="sm" label-class="mb-2" class="mb-1" :state="walletState.beneficiary" invalid-feedback="Beneficiary name is required!" label-cols-sm="3" content-cols-sm label="*Beneficiary Name" >
							<b-form-input id="beneficiary-input" :state="walletState.beneficiary" v-model="wallet.beneficiary"  @focusin="walletState.beneficiary = null" size="sm"></b-form-input>
							</b-form-group>
						
							
						
									
							<b-form-group label-for="phone-input" label-size="sm" label-class="mb-4" class="mb-1" :state="walletState.phone" :invalid-feedback="walletError.phone" label-cols-sm="3" content-cols-sm label="*Phone Number"  description="Commission will be transferred to this number!"> 
							<b-form-input id="phone-input" :state="walletState.phone" v-model="wallet.phone"  @focusin="walletState.phone = null" size="sm" maxlength="11"  ></b-form-input>
							</b-form-group>
							
							
							
							<b-form-group label-for="wallet_name-input" label-size="sm" label-class="mb-2" class="mb-1" :state="walletState.wallet_name" invalid-feedback="Wallet Name is required!" label-cols-sm="3" content-cols-sm label="*Wallet Name">
								<b-form-select v-model="wallet.wallet_name" id="wallet_name-input" :state="walletState.wallet_name" v-on:change="walletState.wallet_name = null" size="sm">
								<b-form-select-option value="" hidden selected >Select Wallet</b-form-select-option>
								<b-form-select-option value="Paytm">Paytm</b-form-select-option>
								<b-form-select-option value="PhonePe">PhonePe</b-form-select-option>
								<b-form-select-option value="GooglePay">Google Pay</b-form-select-option>
								<b-form-select-option value="AmazonPay">Amazon Pay</b-form-select-option>
								<b-form-select-option value="PayZapp">PayZapp</b-form-select-option>
								</b-form-select>
							</b-form-group>
											
											
							<b-form-group :state="walletState.status"  label-for="walletstatus-input" label-size="sm" label-class="mb-2" class="mb-1" invalid-feedback="status is required!" label-cols-sm="3" content-cols-sm label="*Select status">
								<b-form-select v-model="wallet.status" id="walletstatus-input" :state="walletState.status" v-on:change="walletState.status = null" size="sm">
								<b-form-select-option value="" hidden selected placeholder="select status">*Select status</b-form-select-option>
								<b-form-select-option value="1">Active</b-form-select-option>
								<b-form-select-option value="0">In Active</b-form-select-option>
								</b-form-select>
							</b-form-group>
							
						</b-col>
						</b-row>
						
						<b-row class="mt-2">
							<b-col class="text-right bankAccountFotmbtnLayout ">
								
								 <b-button type="reset" variant="light" @click="noAddwallet=0" class="btn-solid-cancel" pill>Cancel</b-button> <b-button pill type="submit" variant="dark" class="mr-2">Save Wallet</b-button>
								 
							</b-col>
						</b-row>
						</form>
					</b-container>
					<b-container fluid>
						<b-row>
							<b-col class="col-md-12 col-sm-12 col-xs-12">
								<div class="container-box">
									<b-row class="mt-4 px-3">
										<b-col lg="6" class="text-left">
											<span class="mr-2">Show</span>
											<b-form-select v-model="perPagewallet" id="perPagewalletSelect" :options="pageOptionswallet" size="sm" class="w-25">
											</b-form-select>
										
										</b-col>
										<b-col lg="4" offset-md="2">
											<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
												<b-input-group size="sm">
													<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
													</b-form-input>
													<b-input-group-append>
														<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
													</b-input-group-append>
												</b-input-group>
											</b-form-group>
										</b-col>
									</b-row>
									<b-row class="px-3 pt-3"> 
										<b-col lg="12">
											<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="recordsWallet" :fields="fieldswallet" :current-page="currentPagewallet" :per-page="perPagewallet" :filter="filter" :filterIncludedFields="filterOnwallet" :sort-by.sync="sortBywallet" :sort-desc.sync="sortDescwallet" :sort-direction="sortDirectionwallet" @filtered="onFiltered">
												<template v-slot:cell(status)="row">
													<b-badge pill variant="warning" v-if="row.value == 0">In Active</b-badge>
													<b-badge pill variant="success" v-else>Active</b-badge>
													
												</template>
												
												<template v-slot:cell(actions)="row">
													<!-- <b-button pill variant="outline-primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button>-->
													<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="showDeletewalletModal(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
												</template>
											</b-table>
										</b-col>
									</b-row>
									<b-row class="px-3">
										<b-col lg="6" class="text-left">
											<span class="mr-2">Showing {{currentPagewallet}} to {{(perPagewallet>recordsWallet.length)?recordsWallet.length:perPagewallet}} of {{recordsWallet.length}} entries</span>
										</b-col>
										<b-col lg="3" offset-md="3">
											<b-pagination v-model="currentPagewallet" pills :total-rows="totalRowswallet" :per-page="perPagewallet" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
										</b-col>
									</b-row>
								</div>
							</b-col>
						</b-row>
					</b-container>

					<!-- ==================================================================================== -->
			
			
			</b-tab>
			
		  </b-tabs>
		</b-container>
				
		</b-card>
				
				
</template>
<script>
//import CartVariant from "@/components/cartVariant.vue";
export default {
  name: 'ProfileBank',
  components: {
  //"cart-variant": CartVariant,
  },
  props: {
   /* cartItems: { type: Array },
    cartData: { type: Object  },
	cartTotalqty:Number,*/
  },
  mounted(){
  //this.inLodcard;
  this.inLodcard();
  },
  computed: {
    
  },
  data() {
    return{
		//urlSavebank:this.$root.WEBURL+'savebankProfile',
		urlSavebank: this.$root.NEWAPIURL+'profileapi/save-bank',
		urlLoadbank: this.$root.NEWAPIURL+'profileapi/load-bannk',
		deleteUrl: this.$root.WEBAPI+'sellerapi/bank-delete',
		urlSavewallet: this.$root.NEWAPIURL+'profileapi/save-wallet',
		urlLoadwallet: this.$root.NEWAPIURL+'profileapi/load-wallet',
		noAddaccount:0,
		totalRows: 1,
        currentPage: 1,
		pageOptions: [10, 20, 50, 100],
		perPage: 10,
		sortBy: '',
		sortDesc: false,
		sortDirection: 'asc',
		filter: null,
		filterOn: [],
		recordsBank: [],
		fieldsbank: [
			{ key: 'id', label: 'ID'},
			{ key: 'beneficiary', label: 'Beneficiary Name'},
			{ key: 'account', label: 'Account Number'},
			{ key: 'bank_name', label: 'Bank Name'},
			{ key: 'ifsc', label: 'IFSC Code'},
			{ key: 'account_type', label: 'Account Type'},
			{ key: 'status', label: 'Status' },
			{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
		],
		profile:{
				beneficiary:'',
				bank_name:'',
				account:'',
				conf_account:'',
				ifsc:'',
				account_type:'',
				status:'',
				},
		profileState:{
			beneficiary:null,
			bank_name:null,
			account:null,
			conf_account:null,
			ifsc:null,
			account_type:null,
			status:null,
		},		
		profileError:{
			beneficiary:null,
			bank_name:null,
			account:'Account number should be valid!',
			conf_account:'Please enter conform account number!',
			ifsc:null,
			account_type:null,
			status:null,
		},
		accountInput:'password',
		
		noAddwallet:0,
		wallet:{
				beneficiary:'',
				phone:'',
				wallet_name:'',
				status:'',
				},
		walletState:{
			beneficiary:null,
			phone:null,
			wallet_name:null,
			status:null,
		},	
		walletError:{
			beneficiary:null,
			phone:'Please enter wallet Phone number!',
			wallet_name:null,
			status:null,
		},	
		totalRowswallet: 1,
		currentPagewallet: 1,
		pageOptionswallet: [10, 20, 50, 100],
		perPagewallet: 10, 
		sortBywallet: '',
		sortDescwallet: false,
		sortDirectionwallet: 'asc',
		filterwallet: null,
		filterOnwallet: [],
		recordsWallet: [],
		fieldswallet: [
			{ key: 'id', label: 'ID'},
			{ key: 'beneficiary', label: 'Beneficiary Name'},
			{ key: 'phone', label: 'Phone Number'},
			{ key: 'wallet_name', label: 'Wallet Name'},
			{ key: 'status', label: 'Status' },
			{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
		],
		
				
		
		
    }
  },
  methods:{
	/* inLodcard(){
		alert('dasd');
	},*/
	inLodcard(){
			
			var self = this;
			self.axios.post(self.urlLoadbank, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error  == 0 || response.data.error == '0'){				
					self.recordsBank = response.data.result;					
					self.totalRows = self.recordsBank.length;
					//self.loading = false; 
				}else {
					//self.$root.forceLogout(response.data.message);
					self.$bvToast.toast(response.message, {
								title: 'Bank',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
						});
					
					
				}
			})
			.catch(function (error) {
				alert(error);
			});
			
			
			self.axios.post(self.urlLoadwallet, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error  == 0 || response.data.error == '0'){				
					self.recordsWallet = response.data.result;					
					self.totalRowswallet = self.recordsBank.length;
					//self.loading = false; 
				}else {
					//self.$root.forceLogout(response.data.message);
					self.$bvToast.toast(response.message, {
								title: 'Wallet',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
						});
					
					
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
			checkFormValidityBank() {
				var valid = true;
				if(this.profile.beneficiary.length < 3){
				valid = false;
				this.profileState.beneficiary = false;
				}else{
				this.profileState.beneficiary= true;
				}
				
				if(this.profile.bank_name.length < 3){
				valid = false;
				this.profileState.bank_name = false;
				}else{
				this.profileState.bank_name= true;
				}
				
				if(this.profile.account.length <1){
					valid = false;
					this.profileState.account = false;
				}else if(!/^[0-9]+$/.test(this.profile.account)){
					this.profileError.account='Account number should be only digits!';
					valid = false;
					this.profileState.account = false;
				
				}else if(this.profile.conf_account.length <1){
					this.profileError.conf_account='Please enter conform account number!';
					valid = false;
					this.profileState.conf_account = false;
				
				}else if(this.profile.account!=this.profile.conf_account){
					this.profileError.conf_account='Account number and confirm account number is not identical';
					valid = false;
					this.profileState.conf_account = false;
				
				}else{
				this.profileState.account= true;
				}
				
				
				
				
				if(this.profile.ifsc.length <11){
					valid = false;
					this.profileState.ifsc = false;
				}else{ 
					var trst = this.isIfscCodeValid(this.profile.ifsc);
					if(trst){
						this.profileState.ifsc= true;
					}else{
						valid = false;
						this.profileState.ifsc = false;
					}
					//console.log('ifscCon:'+trst);
					
				}
				
				
				
				
				/* if(this.profile.ifsc.length <4){
				valid = false;
				this.profileState.ifsc = false;
				}else{
				this.profileState.ifsc= true;
				} */
				if(this.profile.account_type==''){
				valid = false;
				this.profileState.account_type = false;
				}else{
				this.profileState.account_type= true;
				}
				
				if(this.profile.status==''){
				valid = false;
				this.profileState.status = false;
				}else{
				this.profileState.status= true;
				}
				
			return valid;
			},
			isIfscCodeValid(iFSCCode) 
			{
				//var regExp = "^[A-Z]{4}[0][A-Z0-9]{6}$";
				var regExp = /^[A-Za-z]{4}[0-9]{6,7}$/;
				//var isvalid = false;
				
				if (iFSCCode.match(regExp)) {
				  return true;
				} else {
					return true;
				  //return false;
				}
				
			},
			spaceNotAllow($event) {
			
				//var regexp = /^\S*$/; 
				/*var str = this.profile.ifsc;
				
				var strRemoce = str.replace(/\s/g, '');
				this.profile.ifsc = strRemoce;*/
			
			   //console.log($event.keyCode); //keyCodes value
			  let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
			   if(keyCode ==32 )  { // 46 is dot
				  $event.preventDefault();
			   }
			},
			handleSubmitBank(){
				if (!this.checkFormValidityBank()) {
				return;
				}
				var self = this;


			/*var o = self.profile; 
			 {
				prefix: self.customerSeller.prefix,
				fullname: self.customerSeller.fullname,
				email: self.customerSeller.email,
				mobile: self.customerSeller.mobile,
				role: self.customerSeller.role,
				location: self.customerSeller.location,
				workarea: workarea
				} */
			
				self.axios.post(self.urlSavebank, {
					accesskey: self.$session.get('access_key'),
					data: self.profile,
				}).then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						self.$bvToast.toast(response.data.message, {
								title: 'Update Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
						});
						
						self.profile={
							beneficiary:'',
							bank_name:'',
							account:'',
							conf_account:'',
							ifsc:'',
							account_type:'',
							status:'',
							};
						self.profileState = {
							beneficiary:null,
							bank_name:null,
							account:null,
							conf_account:null,
							ifsc:null,
							account_type:null,
							status:null,
						};
						self.noAddaccount=0;
						self.inLodcard();
						//self.initProfile();
					}else{
						self.error_msg = response.data.message;
						self.$bvToast.toast(response.data.message, {
						title: 'Bank',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'danger',
						solid: true,
						appendToast: true
						});
					
					}

				}).catch(function (error) {
						alert(error);
				});
			
			

		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Bank Inforamtion!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.inLodcard();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		showDeletewalletModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Wallet Inforamtion!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.inLodcard();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		checkFormValidityWallet() {
			var valid = true;
			if(this.wallet.beneficiary.length < 3){
			valid = false;
			this.walletState.beneficiary = false;
			}else{
			this.walletState.beneficiary= true;
			}
			
			if(this.wallet.wallet_name.length < 3){
			valid = false;
			this.walletState.wallet_name = false;
			}else{
			this.walletState.wallet_name= true;
			}
			
			if(this.wallet.phone.length <10){
				this.walletError.phone='Please enter wallet Phone number!';
				valid = false;
				this.walletState.phone = false;
			}else if(!/^[0-9]+$/.test(this.wallet.phone)){
				this.walletError.phone='Phone number should be only digits!';
				valid = false;
				this.walletState.phone = false;
			
			}else{
			this.walletState.phone= true;
			}
			
			
			if(this.wallet.wallet_name==''){
			valid = false;
			this.walletState.wallet_name = false;
			}else{
			this.walletState.wallet_name= true;
			}
			
			if(this.wallet.status==''){
			valid = false;
			this.walletState.status = false;
			}else{
			this.walletState.status= true;
			}
		
		return valid;
		},

		handleSubmitWallet(){
					if (!this.checkFormValidityWallet()) {
					return;
					}
					var self = this;
					self.axios.post(self.urlSavewallet, {
						accesskey: self.$session.get('access_key'),
						data: self.wallet,
					}).then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
									title: 'Update Status',
									toaster: 'b-toaster-bottom-right',
									autoHideDelay: 5000,
									variant: 'warning',
									solid: true,
									appendToast: true
							});
							
							self.wallet={
								beneficiary:'',
								phone:'',
								wallet_name:'',
								status:'',
								};
							self.walletState = {
								beneficiary:null,
								phone:null,
								wallet_name:null,
								status:null,
							};
							self.noAddwallet=0;
							self.inLodcard();
							//self.initProfile();
						}else{
							self.error_msg = response.data.message;
							self.$bvToast.toast(response.data.message, {
							title: 'Bank',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'danger',
							solid: true,
							appendToast: true
							});
						
						}

					}).catch(function (error) {
							alert(error);
					});
				
				

			},


    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   lang="scss">


</style>
